import * as Yup from 'yup';

const stepSixSchema = Yup.object().shape({
  usAuth: Yup.string().required('This field is required'),
  usAuthExplain: Yup.string().when('usAuth', {
    is: 'other',
    then: Yup.string().required('This field is required'),
  }),
  citizenship: Yup.mixed().when('usAuth', {
    is: (v) => v !== 'permanent',
    then: Yup.mixed().required('This field is required'),
  }),
  discloseGender: Yup.string(),
  gender: Yup.string().when('discloseGender', {
    is: 'ok_to_say',
    then: Yup.string().required('This field is required'),
  }),
  discloseRace: Yup.string(),
  race: Yup.array().when('discloseRace', {
    is: 'ok_to_say',
    then: Yup.array().of(Yup.string()).min(1, 'Select at least one option').required('Select at least one option'),
  }),
  raceCustom: Yup.string().when('race', {
    is: (value) => value?.includes('other') || false,
    then: Yup.string().required('This field is required'),
  }),
  discloseLgbtq: Yup.string(),
  lgbtq: Yup.string().when('discloseLgbtq', {
    is: 'ok_to_say',
    then: Yup.string().required('This field is required'),
  }),
  discloseMilitary: Yup.string(),
  military: Yup.string().when('discloseMilitary', {
    is: 'ok_to_say',
    then: Yup.string().required('This field is required'),
  }),
  militaryNotes: Yup.string().when('military', {
    is: (value) => value === 'us_military' || value === 'military',
    then: Yup.string().required('This field is required'),
  }),
  athlete: Yup.string(),
  sports: Yup.string().when('athlete', {
    is: (value) => value === 'Club' || value === 'Varsity',
    then: Yup.string().required('This field is required'),
  }),
});

export default stepSixSchema;
